'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _pacomo = require('utils/pacomo');

var _LangPicker = require('./LangPicker');

var _LangPicker2 = _interopRequireDefault(_LangPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// versionNumber is a global (defined with webpack's definePlugin)

var BrandedFooter = function BrandedFooter() {
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'div',
            { className: 'wrapper' },
            _react2.default.createElement(_LangPicker2.default, null),
            _react2.default.createElement(
                'p',
                null,
                'v',
                versionNumber
            )
        )
    );
};

exports.default = (0, _pacomo.pacomoTransformer)(BrandedFooter);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/BrandedFooter.js
// module id = 1294
// module chunks = 0